<template>
    <div class="container"  v-title="'我的评定'">
        <Navigation-bar :class="{'Bokeh':athleteCertificate.show}"></Navigation-bar>
        <div class="container_content" :class="{'Bokeh':athleteCertificate.show}">
            <div class="title">
                <h2>
                    <div @click.stop="setState(!state.show)">
                        <span>{{state.text}}</span>
                        <YD-image :src="state.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                    </div>
                    <div id="title_list" v-show="state.show">
                        <div class="title_list_content">
                            <ul>
                                <li v-for="(item,index) in state.list" :key="index">
                                    <div class="name" v-pressed 
                                        :class="{'active':state.activeIndex == index}"
                                        @click.stop="selectState(index,item.id,item.text)"
                                    >{{item.text}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </h2>
                <p class="subTitle">我的评定</p>
            </div>
            <div id="MyApplyForAssessment">
                <div class="MAFA_scroll">
                    <Pull-refresh
                        v-model="PullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="PullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <div class="MAFA_content">
                            <div class="regulation">
                                <div class="whole" v-show="regulation" v-href="'/Rules/CertificationRegulation'">
                                    <p>「中国职工体育赛事认证体系管理办法」</p>
                                    <p>赛事认证·赛事积分·运动员等级评定</p>
                                    <p><span>点击进入</span><YD-image src="logo_新"></YD-image></p>
                                </div>
                                <div class="simplify" v-show="!regulation" v-href="'/Rules/CertificationRegulation'">
                                    <div>
                                        <span>中国职工体育赛事认证体系管理办法</span><span>点击进入</span>
                                    </div>
                                </div>
                            </div>
                            <div class="cover" v-show="!regulation"></div>
                            <ul>
                                <li v-for="(item,index) in list" :key="index">
                                    <div class="state_content">
                                        <div class="state_info">
                                            <div class="info" v-if="item.ApplyResult == 0">
                                                <span class="state_text">审核中</span>
                                            </div>
                                            <div class="info" v-if="item.ApplyResult == 2">
                                                <span class="state_text" style="background: #FDF0EC;color: #F06E43;">未通过</span>
                                            </div>
                                            <div class="info" v-else-if="item.ApplyResult == 1">
                                                <YD-image src="icon/icon_卡片_赛事认证"></YD-image>
                                                <span>运动员等级已评定</span>
                                            </div>
                                            <div class="info" v-else></div>
                                            <div class="time">{{ item.AuditTIme | dateFormat('yyyy年MM月dd日')}}</div>
                                        </div>
                                        <div class="match_name">
                                            <p :style="item.ApplyResult == 2?'width:3.8rem':''">{{item.SubLeagueName}}</p>
                                            <button  v-href="'/Athletes/AthleteCertification?ApplyId='+item.ApplyId" v-if="item.ApplyResult == 2">
                                                <YD-image src="icon/icon_卡片_提交"></YD-image>
                                                <span>重新提交</span>
                                            </button>
                                        </div>
                                        <div class="audit_failure" v-if="item.ApplyResult == 2">
                                            <dl>
                                                <dt>未通过原因</dt>
                                                <dd>
                                                    <p>{{item.RejectReason}}</p>
                                                </dd>
                                            </dl>
                                        </div>
                                        <div class="Athletes" v-if="item.ApplyResult == 1" style="padding:0.05rem 0 0.28rem 0">
                                            <ol>
                                                <li>
                                                    <YD-image :src="`icon/icon运动员等级_职工${numberToChinese(item.GranteeList[0].ApplyLevel)}级`"></YD-image>
                                                    <span>{{item.GranteeList[0].RealName}}，</span>
                                                    <span>职工{{item.GranteeList[0].ApplyLevel | numberToChinese}}级</span>
                                                </li>
                                            </ol>
                                            <div style="bottom:0.38rem" @click="lookAthletes(item.ApplyId, item.SubLeagueName, item.GranteeList)">
                                                <span>更多</span>
                                                <YD-image src="icon/icon_card_arrow_3"></YD-image>
                                            </div>
                                        </div>
                                        <div class="Athletes" v-else>
                                            <ol :class="{'hide':IndexArr.indexOf(index) == -1}">
                                                <li v-for="(granteeItem,granteeIndex) in item.GranteeList" :key="granteeIndex">
                                                    <span>{{granteeItem.RealName}}，</span>
                                                    <span>职工{{granteeItem.ApplyLevel | numberToChinese}}级</span>
                                                </li>
                                            </ol>
                                            <div v-if="item.GranteeList.length > 1" @click="switchBtn(index)">{{(IndexArr.indexOf(index) > -1) ? '收起' : '展开'}}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="load_more" v-show="loadMore">{{loadMore}}</div>
                            <div class="operation">
                                <button v-href="'/Athletes/AthleteCertification'">申请评定</button>
                            </div>
                        </div>
                    </Pull-refresh>
                </div>
                
            </div>
        </div>
        <div id="athletes_container" v-show="athletes.show">
            <div class="athletes_content">
                <div class="title">运动员</div>
                <div class="list">
                    <ul>
                        <li v-for="(item,index) in athletes.list" :key="index">
                            <div class="icon">
                                <YD-image :src="`icon/icon运动员等级_职工${numberToChinese(item.ApplyLevel)}级`"></YD-image>
                            </div>
                            <div class="info">
                                <p class="name">{{item.RealName}}</p>
                                <p class="grade">职工{{item.ApplyLevel | numberToChinese}}级</p>
                            </div>
                            <span class="look" @click="lookOverCertificate(item.CertificateNumber)">查看证书</span>
                        </li>
                    </ul>
                    <div class="cover"></div>
                </div>
                <div class="operation">
                    <button style="color: #3A3F49;" @click="()=>{athletes.show = false}">关闭</button>
                    <button style="color: #FFA61C;" @click="download(1)">下载</button>
                </div>
            </div>
            <div class="athletes_mask" @click="()=>{athletes.show = false}"></div>
        </div>
        <div id="athlete_certificate" v-show="athleteCertificate.show" ref="athlete_certificate">
            <div class="certificate_modal share">
                <YD-image class="certificate_close" src="icon/icon_close" @click.native="athleteCertificate.show = false"></YD-image>
                <div class="certificate_content" v-certificateScale>
                    <YD-image class="certificate_medal" :src="'athlete_certificate/奖章'+athleteCertificate.AthleteLevel+'级'" ></YD-image>
                    <YD-image class="certificate_grade" :src="'athlete_certificate/职工'+athleteCertificate.AthleteLevel+'级'" ></YD-image>
                    <ul class="certificate_info">
                        <li>{{athleteCertificate.AthleteName}}</li>
                        <li>{{athleteCertificate.AthleteGender==2?'女':'男'}}</li>
                        <li>{{athleteCertificate.AthleteMemberNo}}</li>
                        <li>{{athleteCertificate.EventsName}}</li>
                        <li>{{athleteCertificate.SubLeagueName + athleteCertificate.LeagueGroupName + athleteCertificate.MatchScore}}</li>
                    </ul>
                    <div class="certificate_serialNumber">证书编号：{{athleteCertificate.CertificateNumber}}</div>
                    <div class="certificate_date">{{athleteCertificate.CertificateTime | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
                <!-- 低版本兼容-->
                <template v-if="$appVersion < '22093000'">
                    <p>请拨打电话4006240066联系客服邮寄证书</p>
                    <button class="certificate_share" @click="download(2)">保存</button>
                </template>
                <template v-else>
                    <p><span @click="makingCalls">拨打电话</span>联系客服邮寄证书</p>
                    <button class="certificate_share" @click="share">分享</button>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import {
    GetMyAthleteLevelCertificateApplyList,
    GetAthleteLevelCertificate,//获取运动员等级证书信息
    GetAthleteLevelCertificateFile,//获取运动员等级证书下载信息（单个）
    GetCertificatesPackageFile//获取运动员等级证书下载信息（多个，批量下载）
} from "@/api"
import {
    numberToChinese,
    convertSize
} from '@js'
import { 
    saveImage,
    saveFile,
    share,
    makingCalls
} from "@js/appInteraction"
export default {
    name:"MyApplyForAssessment",
    components:{
        PullRefresh
    },
    data(){
        return {
            regulation: true,//管理方法显示样式
            roll: 0,//滚动距离
            state:{
                show:false,
                text:'全部',
                Id:-1,
                activeIndex:0,
                list:[
                {id:-1,text:'全部'},
                {id:1,text:'已评定'},
                {id:0,text:'审核中'},
                {id:2,text:'未通过'}]
            },
            list:[],
            lastId:0,
            loadMore:'',
            isGetData:true,
            IndexArr:[],
            athletes:{
                ApplyId:0,
                SubLeagueName:'',
                list:[],
                show:false
            },
            athleteCertificate:{},//运动员证书显示
            PullRefresh:{
                loading:false,
                text:''
            }
        }
    },
    created(){
        this.getListData(0);
    },
    mounted(){
        var _this = this;
        $('#MyApplyForAssessment .MAFA_scroll').scroll(function () {
            var scroll = $('#MyApplyForAssessment .MAFA_scroll').scrollTop();
            _this.roll = scroll;
        });
        var h = document.body.offsetHeight;
        if(convertSize(13.4) > h){
            this.$refs['athlete_certificate'].style.alignItems = "normal";
        }
    },
    watch:{
        roll:function(scroll){
            $('#MyApplyForAssessment .MAFA_scroll').scrollTop(this.roll); 
            var h = $('#MyApplyForAssessment .MAFA_scroll').innerHeight(),
                cH = $('#MyApplyForAssessment .MAFA_content').height(),
                wholeH =  $('#MyApplyForAssessment .regulation').height(),
                simplifyH = $('#MyApplyForAssessment .regulation .simplify').height();
            //管理办法
            if(scroll > wholeH - simplifyH){
                this.regulation = false;
            }else{
                this.regulation = true;
            }
            if(cH < this.roll + h + 4){
                if(!this.isGetData){ 
                    return ;
                }
                this.getListData(this.lastId);
            }
        },
    },
    methods:{
        numberToChinese,
        setState(show){
            this.state.show = show;
        },
        selectState(index,id,text){
            var obj = this.state;
            if(obj.activeIndex != index){
                obj.activeIndex = index;
                obj.Id = id;
                obj.text = text;
                this.lastId = 0;
                this.list = [];
                this.isGetData = true;
                this.getListData(0);
            }
            obj.show = false;
        },
        getListData(lastId,isRefresh){
            if(!isRefresh){
                this.isGetData = false;
                this.loadMore = '数据加载中...';
            }
            GetMyAthleteLevelCertificateApplyList({
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                },
                ApplyResult:this.state.Id > -1 ? this.state.Id : null
            }).then(data=>{
                this.PullRefresh.loading = false;
                this.isGetData = true;
                this.loadMore = '';
                if(data.Code == 0){
                    if(isRefresh){
                        this.isGetData = true;
                        this.PullRefresh.text = '数据刷新成功';
                    }
                    if(data.ApplyList.length == 0){
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }else{
                            this.loadMore = '到底了';
                        }
                        this.isGetData = false;
                    }else{
                        if(lastId == 0){
                            this.list = data.ApplyList;
                        }else{
                            this.$set(this,"list",[...this.list, ...data.ApplyList]);
                        }
                        this.lastId = data.ApplyList[data.ApplyList.length-1].ApplyId;
                    }
                }else{
                    if(isRefresh){
                        this.PullRefresh.text = '数据刷新失败';
                    }
                }
            }).catch(err=>{
                if(isRefresh){
                    this.PullRefresh.loading = false;
                    this.PullRefresh.text = '数据刷新失败';
                }else{
                    this.isGetData = true;
                    this.loadMore = '';
                }
            })
        },
        switchBtn(index){
            var i = this.IndexArr.indexOf(index);
            if(i > -1){
                this.IndexArr.splice(i,1);
            }else{
                this.IndexArr.push(index);
            }
        },
        lookAthletes(ApplyId, SubLeagueName, list){
            this.setState(false);
            this.athletes = {
                show: true,
                ApplyId,
                SubLeagueName,
                list
            }
        },
        lookOverCertificate(CertificateNumber){
            if(!CertificateNumber)return;
            GetAthleteLevelCertificate({
                CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    var obj = data.Certificate;
                    this.athleteCertificate = {
                        show: true,
                        ...obj
                    }
                }
            })
        },
        download(type){
            if(type == 1){
                GetCertificatesPackageFile({
                    ApplyId: this.athletes.ApplyId
                }).then(data=>{
                    if(data.Code == 0){
                        saveFile(data.CertificatesPackageFile, this.athletes.SubLeagueName+'.zip');
                    }
                })
            }else{
                GetAthleteLevelCertificateFile({
                    CertificateNumber: this.athleteCertificate.CertificateNumber
                }).then(data=>{
                    if(data.Code == 0){
                        saveImage(data.CertificateFile);
                    }
                })
            }
        },
        //分享
        share(){
            GetAthleteLevelCertificateFile({
                CertificateNumber: this.athleteCertificate.CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    share({
                        Type: 7,
                        Title: "",
                        Text: "",
                        Link: "https://m.dazhongyundong.com/app_download/",
                        LinkText: "立即下载APP：",
                        ImgLink: data.CertificateFile
                    });
                }
            })
        },
        //拨打电话
        makingCalls(){
            makingCalls('4006240066');
        },
        onRefresh(){
            this.lastId = 0;
            this.getListData(0,true);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@assets/scss/ProjectSelectTitle.scss";
.title{
    .title_list_content{
        overflow-y: hidden !important;
        padding-bottom: 0.24rem;
    }
    .active{
        background: #F3F3F3;
    }
}
#MyApplyForAssessment{
    position: relative;
    overflow: hidden;
    .MAFA_scroll{
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 200px;
        box-sizing: border-box;
        .MAFA_content{
            width: 100%;
            height: auto;
        }
    }
    @include regulation;
    .cover{
        width: 100%;
        height: 40px;
        background: #fff;
        position:absolute;
        top: 64px;
        left: 0;
        z-index: 2;
    }
    ul{
        padding: 0 40px;
        padding-top: 40px;
    }
    ul>li{
        width: 100%;
        height: auto;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 24px;
        .state_content{
            height: auto;
            width: 100%;
            border-radius: 20px;
            .state_info{
                height: 96px;
                padding: 8px 32px 0 16px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .info{
                    font-size: 28px;
                    color: #FFA61C;
                    letter-spacing: 0;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    .state_text{
                        display: inline-block;
                        width: 132px;
                        @include line-height(64px);
                        background: #F9F9F9;
                        border-radius: 36px;
                        font-size: 28px;
                        color: #FFA61C;
                        font-weight: 500;
                        text-align: center;
                        margin-right: 12px;
                    }
                    img{
                        width: 60px;
                        height: 60px;
                        margin-right: 8px;
                    }
                }
                .time{
                    font-size: 28px;
                    color: #7E7E7F;
                    text-align: right;
                    line-height: 48px;
                    font-weight: 500;
                }
            }
            .match_name{
                height: 66px;
                width: 100%;
                padding: 0 32px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                p{
                    width: 100%;
                    font-size: 32px;
                    color: #1B1C1E;
                    letter-spacing: 0;
                    font-weight: 500;
                    @include ellipsis;
                }
                button{
                    width: 174px;
                    height: 66px;
                    background: #1B1C1E;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 26px;
                    color: #FFFFFF;
                    text-align: center;
                    font-weight: 500;
                    img{
                        width: 32px;
                        height: 32px;
                    }
                }
            }
            .audit_failure{
                height: auto;
                padding: 24px 32px;
                box-sizing: border-box;
                line-height: 34px;
                font-size: 24px;
                border-top: 1px #F0F0F0 solid;
                position: relative;
                margin-top: 32px;
                dl{
                    display: flex;
                    dt{
                        width: 150px;
                        font-size: 28px;
                        color: #F06E43;
                        letter-spacing: 0;
                        font-weight: 500;
                    }
                    dd{ 
                        width: 390px;
                        p{
                            color: #7E7E7F;
                            font-weight: 400;
                            width: 390px;
                            max-height: 204px;
                            overflow-y: auto;
                        }
                    }
                }
            }
            .audit_failure + .Athletes{
                border-top: 1px #F0F0F0 solid;
                padding-top: 31px;
            }
            .Athletes{
                position: relative;
                padding-bottom: 24px;
                padding-top: 11px;
                ol li{
                    width: 100%;
                    font-size: 28px;
                    color: #3A3F49;
                    line-height: 48px;
                    font-weight: 400;
                    padding-left: 32px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    &:last-of-type{
                        margin-bottom: 0;
                    }
                    img{
                        width: 60px;
                        height: 60px;
                        margin-right: 8px;
                    }
                    span:nth-of-type(2){
                        color: #7E7E7F;
                    }
                }
                .hide{
                    height: 48px;
                    overflow: hidden;
                }
                >div{
                    line-height: 40px;
                    font-size: 28px;
                    color: #FFA61C;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: right;
                    position: absolute;
                    right: 44px;
                    bottom: 26px;
                    img{
                        width: 32px;
                        height: 32px;
                        margin-left: 6px;
                        margin-right: -8px;
                    }
                }
            }
        }
    }
    .operation{
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 70px;
        button{
            width: 670px;
            @include line-height(92px);
            background: #F5F7F5;
            border-radius: 20px;
            font-size: 32px;
            color: #1B1C1E;
            letter-spacing: 6px;
            text-align: center;
            font-weight: 500;
            display: block;
            margin: 0 auto;
        }
    }
}
#athletes_container{
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .athletes_content{
        width:670px;
        height:726px;
        background: #FFFFFF;
        box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-top: 10%;
        position: relative;
        z-index: 2;
        .title{
            height: 168px;
            line-height: 50px;
            font-size: 36px;
            color: #3A3F49;
            font-weight: 500;
            padding: 62px 0 0 54px;
            box-sizing: border-box;
        }
        .list{
            height: 468px;
            width: 100%;
            position: relative;
            overflow: hidden;
            ul{
                height: 100%;
                width: 100%;
                overflow-y: auto;
                li{
                    padding: 0 40px;
                    height: 76px;
                    display: flex;
                    margin-bottom: 48px;
                    position: relative;
                    .icon{
                        height: 76px;
                        width: 76px;
                        position: relative;
                        img{
                            height: 76px;
                            width: 76px;
                        }
                    }
                    .info{
                        width: 450px;
                        padding-left: 24px;
                        padding-right: 60px;
                        box-sizing: border-box;
                        p{
                            font-weight: 400;
                        }
                        .name{
                            @include line-height(44px);
                            font-size: 28px;
                            color: #3A3F49;
                        }
                        .grade{
                            font-size: 24px;
                            color: #7E7E7F;
                            font-weight: 400;
                            margin-top: -2px;
                        }
                    }
                    .look{
                        font-size: 28px;
                        color: #FFA61C;
                        font-weight: 500;
                        line-height: 40px;
                        position: absolute;
                        top: 0;
                        right: 40px;
                    }
                }
            }
            .cover{
                width: 100%;
                height: 152px;
                background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 42%, #FFFFFF 65%);
                border-radius: 20px;
                position: absolute;
                bottom: -40px;
                left: 0;
            }
        }
        .operation{
            width: 100%;
            height: 90px;
            display: flex;
            border-top: 1.2px #EFEFEF solid;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                text-align: center;
                font-weight: 500;
                border-right: 1px #EFEFEF solid;
                position: relative;
                &:last-of-type{
                    border-right: none;
                }
            }
        }
    }
    .athletes_mask{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.50);
    }
}
@include athlete_certificate;
</style>